import { render, staticRenderFns } from "./Personen.vue?vue&type=template&id=04cac824&"
import script from "./Personen.vue?vue&type=script&lang=ts&"
export * from "./Personen.vue?vue&type=script&lang=ts&"
import style0 from "./Personen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports